import { workspaceLocales } from '@citrite/workspace-ui-platform';
import {
	ErrorConfigurationSchema,
	RemediationItem,
} from 'CtxErrorMapper/errorConfigSchema';
import { ErrorMapperBase } from 'CtxErrorMapper/ErrorMapperBase';
import { RemediationOSName } from 'CtxErrorMapper/types';

const defaultRemediationInfoKey = 'DefaultRemediationInfoKey';
// allow-unused-exports: will be used in a later PR
export class Remediation extends ErrorMapperBase {
	public constructor(
		private readonly remediationItem: RemediationItem,
		errorConfig: ErrorConfigurationSchema,
		currentLocale: workspaceLocales,
		remediationOSName: RemediationOSName
	) {
		super(errorConfig, currentLocale, remediationOSName);
	}

	public getLocalizedDescription(): string {
		return (
			this.getLocalizedString(this.remediationItem.remediationInfoKey) ||
			this.getLocalizedString(defaultRemediationInfoKey)
		);
	}

	public getRemediationAction(): string {
		return this.remediationItem.remediationAction;
	}
}
